module.exports = "/7/4-tham-so-mac-dinh-tham-so-hang/index.html.b234bc219b3b3db4f46f8d654d7af624.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30382.md
 ** module id = 564
 ** module chunks = 0
 **/